import React from "react"

const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8.977" height="8.971" viewBox="0 0 8.977 8.971">
      <path id="Path_1139" data-name="Path 1139" d="M9.119,6.217l-.463,2.12a.586.586,0,0,0,.159.54.609.609,0,0,0,.54.158l2.113-.464a.586.586,0,0,0,.29-.159L17.1,3.065a1.76,1.76,0,0,0,0-2.49,1.8,1.8,0,0,0-2.49,0L9.28,5.928A.586.586,0,0,0,9.119,6.217Zm6.329-4.81a.6.6,0,0,1,.83,0,.592.592,0,0,1,0,.83l-.415.415-.83-.83ZM10.227,6.635,14.2,2.652l.824.826L11.046,7.462,9.99,7.692Z" transform="translate(-8.643 -0.075)" fill="#111" />
    </svg>
  )
}
export { EditIcon };